import {Injectable} from '@angular/core';

@Injectable()
export class CommandsSound3D {
    constructor() {

    }

    createListener() {
    }

    emitSound() {
    }

    load3DSound() {
    }
}
